// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import FinishedBadgeIcon from '../../assets/images/card-badge.svg';
import ScrollIcon from '../../assets/images/scroll-down-icon.svg';
import WorkshopExpiringIcon from '../../assets/images/workshop-expiring-icon.svg';
import LevelMeter from '../LevelMeter';
import InfoText from './components/InfoText';
import { Link } from 'react-router-dom';

const otherS = {
  Wrapper: styled.div`
    height: 100%;
    overflow: hidden;
    border-radius: 6px;
    position: relative;
  `,
  MinimalInfo: styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    transition: filter;
    transition-timing-function: cubic-bezier(0.77, -0.02, 0.32, 0.99);
    transition-duration: 300ms;
    filter: brightness(100%);
  `,
  ThumbnailWrapper: styled.div`
    width: 100%;
    height: 142px;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
  `,
  Thumbnail: styled.img`
    width: 100%;
  `,
  OwnerTag: styled.div`
    font: 12px Noto Sans TC;
    color: #FFFFFF;
    background: #EF8200 0% 0% no-repeat padding-box;
    padding: 3px 8px;
    border-radius: 16px;
    border: 2px solid #ffd163;
  `,
  TagsContainer: styled.div`
    position: absolute;
    display: flex;
    bottom: 11px;
    left: 16px;
  `,
  Tag: styled.div`
    font: 12px Noto Sans TC;
    color: #313131;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    padding: 3px 10px;
    border-radius: 16px;
    margin-right: 10px;
  `,
  OwnerFullContainer: styled.div`
    display:flex;
    margin-top: 5px;
  `,
  TypeTag: styled.div`
    min-width: 72px;
    font-size: 16px;
    color: #FFFFFF;
    white-space: nowrap;
    background: #313131 0% 0% no-repeat padding-box;
    /* width: 72px; */
    height: 35px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    position: absolute;
    left: -4px;
    top: 12px;
  `,
  TypeTagShadow: styled.div`
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    background: #313131 0% 0% no-repeat padding-box;
    width: 4px;
    height: 35px;
    border-radius: 4px 0px 0px 4px;
    position: absolute;
    left: -4px;
    top: 12px;
    transition: left 0.3s;
  `,
  Content: styled.div`
    padding: 7px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  `,
  Title: styled.div<{ isFull?: boolean }>`
    overflow: hidden;
    font-weight: ${ props => props.isFull ? 500 : 700};
    font-size: 16px;
    line-height: 23px;
    color: #313131;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${ props => props.isFull ? '4' : '2'};
    -webkit-box-orient: vertical;
    width: 100%;
  `,
  InfoContainer: styled.div`
    display: flex;
    padding-top: 10px;
    flex-wrap: wrap;
  `,
  OwnerContainer: styled.div`
    position: absolute;
    top: 12px;
    right: 16px;
  `,
  DomainContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  `,
  FullTagContainer: styled.div`
    display: flex;
    padding-top: 8px;
    flex-wrap: wrap;
  `,
  InfoText: styled(InfoText)`
    display: flex;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 10px;
    font: 14px Noto Sans TC;
    color: #313131;

    img {
      margin-right: 4px;
    }

  `,
  FinishedBadge: styled.img.attrs({ src: FinishedBadgeIcon, alt: 'finished-badge'})`
    max-width: 25px;
    margin-right: 5px;
    z-index: 1;
    transition: all 0.3s ease-in-out 0.05s;
  `,
  FullInfoContent: styled.div`
    padding: 11px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

  `,
  FullInfo: styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    overflow: auto;

    // slide-in-bottom transition
    position: absolute;
    top: 100%;
    z-index: 1;
    transition: top;
    transition-timing-function: cubic-bezier(0.77, -0.02, 0.32, 0.99);
    transition-duration: 300ms;
  `,
  FullInfoContainer: styled.div`
    padding: 8px;
  `,
  Footer: styled.div`
    margin-top: auto;
    display: flex;
  `,
  FooterWorkshopDatesContainer: styled.div`
    margin-top: auto;
  `,
  LevelMeter: styled(LevelMeter)`
    margin-right: auto;
  `,
  ScrollDownFooter: styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 1;
  `,
  ScrollDownMask: styled.div`
    width: 100%;
    height: 15px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8) 33.33%);
    border-radius: 0px 0px 6px 6px;
  `,
  ScrollDownIcon: styled.img.attrs({ src: ScrollIcon, alt: 'scroll-down-icon' })`
    animation: MoveUpDown 1s linear infinite;
    position: absolute;
    right: 7px;
    bottom: 12px;

    @keyframes MoveUpDown {
      0%, 100% {
        bottom: 12px;
      }
      50% {
        bottom: 24px;
      }
    }
  `,
  FooterWorkshopDatesText: styled.div`
    font: 13px Noto Sans TC;
    color: #666666;
  `,
  FooterText: styled.div<{ isWorkshopExpiring?: boolean, setLeft?: boolean }>`
    font: 14px Noto Sans TC;
    color: #666666;
    display: flex;
    align-items: center;
    ${props => props.setLeft ? 'margin-left: auto;' : null}
    ${props => props.isWorkshopExpiring && `
      font-weight: 500;
      color: #FE4747;

      &::before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 18px;
        background-image: url(${WorkshopExpiringIcon});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin-right: 4px;
      }
    `}
  `,
  ProgressBar: styled.div<{ completionProgress: number}>`
    position: absolute;
    bottom: 0px;
    width: 100%;
    background-color: #DEDEDE;
    height: 6px;
    border-radius: 0 0 6px 6px;
    transition: height 0.3s;

    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0px;
      width: ${props => props.completionProgress * 100}%;
      background-color: #EF8200;
      height: 6px;
      border-radius: ${props => props.completionProgress * 100 < 95 ? '0' : '0 0 6px 6px;'};
      transition: height 0.3s;
    }
  `
};

const Container = styled(Link)`
  height: 290px;
  width: 260px;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    ${otherS.TypeTagShadow} {
      left: 2px;
    }

    ${otherS.MinimalInfo} {
      filter: brightness(70%);
    }

    ${otherS.FullInfo} {
      top: 0;
    }
  }

  &:not(:hover) {
    ${otherS.ScrollDownFooter} {
      display: none;
    }
  }
`;

const TagSecondary = styled(otherS.Tag)`
  background: #DEDEDE 0% 0% no-repeat padding-box;
  margin-bottom: 8px;
`

export const S = {
  ...otherS,
  Container,
  TagSecondary,
}
